import { Pipe, PipeTransform } from '@angular/core'
import { LocaleService } from '../services/locale/locale-service'
/**
 * locale 이름 순서 바꾸기 pipe
 */
@Pipe({
  name: 'localeName',
})
export class LocaleNamePipe implements PipeTransform {
  constructor(private localeService: LocaleService) { }

  transform(value?: { firstName?: string, lastName?: string }): string {
    if (!value) {
      return ""
    }
    return this.localeService.getLocaleName(value.firstName, value.lastName)
  }
}
